import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import ReactInputMask from "react-input-mask";
import { toast } from "react-toastify";
import { Skeleton } from "primereact/skeleton";
import {
	Col,
	Form,
	FormControl,
	InputGroup,
	OverlayTrigger,
	Row,
	Tooltip,
	Modal,
	Button,
	Spinner,
} from "react-bootstrap";
import {
	Container,
	Filters,
	HomeSearch,
	HomeSelect,
	Materials,
	MaterialsList,
	ObjectList,
	Objects,
} from "./styles";
import { FaSearch } from "react-icons/fa";
import Error from "../../../components/Error";
import { CardMostUsedList } from "../../../components/card-most-used-list";

import logo from "../../../../assets/img/dstore_lead_logo.svg";

import { home } from "../../../services/home.service";
import { newLead } from "../../../services/lead.service";
import { IMaterialResponse } from "../../../models/IMaterialResponse";
import { IObjectResponse } from "../../../models/IObjectResponse";
import { IContent } from "../../../models/IContent";
import { FlatCardObject } from "../../../components/flat-card-object";
import { CardList } from "../../../components/card-list";
import { listKnowledges } from "../../../services/filters.service";

import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import SystemContext from "../../../../context/systemContext/context";
import UsuarioContext from "../../../../context/userContext/context";
import { subscription } from "../../../services/login/login.service";
import { useLocalStorage } from "react-use";
import { ISubscription } from "../../../models/ISubscriptionDetails";
import { removeFavorite } from "../../../services/favorites.service";
import { colors } from "../../../../theme/theme";
import { useRecoilState } from "recoil";
import { subscriptionState } from "../../../../hooks/atoms/subscriptions";

interface LeadProps {
	name: string;
	email: string;
	phone: string;
}

declare global {
	interface Window { // ⚠️ notice that "Window" is capitalized here
		RDStationForms: any;
	}
}

const validationSchema = Yup.object({
	name: Yup.string().required("Este campo é obrigatório"),
	email: Yup.string()
		.email("E-mail inválido")
		.required("Este campo é obrigatório"),
	phone: Yup.string(),
}).required();

export const Home = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const { width } = useWindowDimensions();
	const { systemConfig, update } = useContext(SystemContext)
	const { user } = useContext(UsuarioContext)
	const { register, handleSubmit, control, formState: { errors } } = useForm<LeadProps>({ resolver: yupResolver(validationSchema) });

	const [mostUsed, setMostUsed] = useState<any>([])
	const [lastMaterials, setLastMaterials] = useState<any>([])
	const [mostPopular, setMostPopular] = useState<any>([])
	const [searchContent, setSearchContent] = useState<any>('')
	const [searchCategory, setSearchCategory] = useState<any>('disciplines')

	const [loadingHome, setLoadingHome] = useState<boolean>(false)
	const [loadingMostAccess, setLoadingMostAccess] = useState<boolean>(false)
	const [loadingSubmitLead, setLoadingSubmitLead] = useState<boolean>(false)
	const [showLeadModal, setShowLeadModal] = useState<boolean>(!user.token ? systemConfig.showLeadModal : false)
	// const [, setSubscriptionDetails] = useLocalStorage<ISubscription | {}>('subscription', {})
	const [subscriptionDetails, setSubscriptionDetails] = useRecoilState(subscriptionState)

	const queryParams = new URLSearchParams(window.location.search)
	const queryLead = queryParams.get("lead")

	useEffect(() => {
		if (user.token) {
			subscription().then((res) => {
				setSubscriptionDetails(res)
			})
		}
	}, [])

	useEffect(() => {
		if (queryLead) {
			setShowLeadModal(false)
			update({ ...systemConfig, showLeadModal: false })
		}

		if (window.RDStationForms) {
			new window.RDStationForms('dstore-plataforma-34da66116d1bcf6ff3e9', 'UA-27132815-1').createForm();
		}
	}, [])

	useEffect(() => {
		setLoadingHome(true)
		home().then((res) => {
			setLastMaterials(res.recent_materials)
			setMostPopular(res.most_accessed)
			setLoadingHome(false);
		}).catch(() => setLoadingHome(true))
	}, [])

	useEffect(() => {
		setLoadingMostAccess(true);
		listKnowledges().then((res: IContent[]) => {
			setMostUsed(res);
			setLoadingMostAccess(false);
		});
	}, []);

	const handleInpuSearch = () => {
		switch (searchCategory) {
			case "unities":
				history.push(`/unity/?search=${searchContent}`);
				break;
			case "themes":
				history.push(`/themes/?search=${searchContent}`);
				break;
			case "disciplines":
				history.push(`/disciplines/?search=${searchContent}`);
				break;
			case "objects":
				history.push(`/objects/?search=${searchContent}`);
				break;
			default:
				history.push("/home/");
				break;
		}
	};

	const onKeyUp = (event: any) => {
		if (event.charCode === 13) {
			handleInpuSearch();
		}
	};

	const onSubmit = (lead: LeadProps) => {
		setLoadingSubmitLead(true);
		window.dataLayer.push({
			event: 'DSlead',
		});
		newLead(lead).then(() => {
			setShowLeadModal(false)
			update({ ...systemConfig, showLeadModal: false })
		}).catch(() => {
			toast.error('Ocorreu um erro ao enviar suas informações. Tente novamente.')
		}).finally(() => {
			setLoadingSubmitLead(false);
		});
	}

	const handleRemoveFavorite = (id: number) => {
		removeFavorite(id).then(() => {
			toast.success('Material removido com sucesso!')
		}).catch((err: any) => {
			toast.error('Ocorreu um erro ao remover este material.')
		})
	}


	return (
		<Container>
			<Filters className="mt-4 mb-2">
				<HomeSelect>
					<Form.Select onChange={(e) => { setSearchCategory(e.target.value) }} className="ds-select" defaultValue={searchCategory} aria-label={translation('filters.objectType')}>
						<option value="disciplines">{translation('components.menu.disciplines')}</option>
						<option value="unities">{translation('components.menu.unities')}</option>
						<option value="objects">{translation('components.menu.objects')}</option>
					</Form.Select>
				</HomeSelect>

				<HomeSearch>
					<InputGroup className="mb-2 mt-sm-0 ds-input-group">
						<FormControl
							onChange={(e) => { setSearchContent(e.target.value) }}
							className="input-text"
							placeholder={translation('filters.search')}
							aria-label={translation('filters.search')}
							aria-describedby="basic-addon1"
							onKeyPress={onKeyUp}
						/>
						<OverlayTrigger placement={'top'} overlay={<Tooltip id="search">Pesquisar Material</Tooltip>} >
							<InputGroup.Text style={{ cursor: 'pointer', textAlign: 'center', border: '1px solid #EEEEEE' }} id="basic-addon1" onClick={handleInpuSearch}><FaSearch color='#606060' size={16} style={{ marginRight: 10 }}></FaSearch></InputGroup.Text>
						</OverlayTrigger>
					</InputGroup>
				</HomeSearch>

			</Filters>

			{/* <Row style={{ marginBottom: 24 + 'px' }}>
                <span className="text-darker-grey">{translation('home.moreThan')} <b> {materialQuantity} </b> {translation('home.materialFound')}</span>
            </Row> */}

			<CardMostUsedList contents={mostUsed} loading={loadingMostAccess} />
			<>
				<MaterialsList>
					<h5>{translation("components.card-news-list.Title")}</h5>
					{loadingHome ? (
						<>
							<Row>
								<Col sm={6}>
									<Skeleton width="100%" height="90px" />
								</Col>
								<Col sm={6}>
									<Skeleton width="100%" height="90px" />
								</Col>
							</Row>
							<Row className="mt-3">
								<Col sm={6}>
									<Skeleton width="100%" height="90px" />
								</Col>
								<Col sm={6}>
									<Skeleton width="100%" height="90px" />
								</Col>
							</Row>
						</>
					) : (
						<>
							{!!lastMaterials.length && (
								<>
									<Materials>
										{lastMaterials.map(
											(
												material: IMaterialResponse,
												index: any
											) => (
												<>
													{material.type_product !==
														"Media" && (
															<CardList
																key={index}
																material={material}
																removeFavorite={
																	handleRemoveFavorite
																}
																isNew
															/>
														)}
												</>
											)
										)}
									</Materials>
								</>
							)}
						</>
					)}

				</MaterialsList>

				<ObjectList>
					<h5>{translation('components.card-object.Title')}</h5>
					{loadingHome ? (
						<>
							<Row>
								<Col sm={6}>
									<Skeleton width="100%" height="256.5px" />
								</Col>
								<Col sm={6}>
									<Skeleton width="100%" height="256.5px" />
								</Col>
							</Row>
						</>
					) : (
						<>
							{!!mostPopular.length && (
								<Objects>
									{mostPopular.map((obj: IObjectResponse, index: any) => (
										// <CardObject key={index} object={obj} />
										<FlatCardObject object={obj} key={index} />
									))}
								</Objects>
							)}
						</>
					)}
				</ObjectList>
			</>

			<Modal
				size="lg"
				className="modal-lead"
				aria-labelledby="contained-modal-title-vcenter"
				centered
				backdrop="static"
				show={showLeadModal}
				onHide={() => setShowLeadModal(false)}
			>
				<Row style={{ marginLeft: '0px', marginRight: '0px' }}>
					{
						width > 992 &&
						<Col lg={6} className="p-5 bg-modal-lead">
							<h1 className="text-white"><b>Bem-vindo(a) à DStore!</b></h1>
						</Col>
					}
					<Col lg={6} className="p-2-5">
						<div className="text-center mb-4 mt-4">
							<img src={logo} width="55%" height="55%" alt="" className="mb-2" />
							<p className="font-light font-16">{translation('lead.collection')}</p>
						</div>
						<div role="main" id="dstore-plataforma-34da66116d1bcf6ff3e9"></div>
						{/* <Form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-darker-grey">{translation('lead.username')}:</Form.Label>
                                <Form.Control maxLength={40} type="text" placeholder={translation('lead.username')} {...register("name", { required: true })} />
                                {errors.name ? (<div className="w-100"> <Error>{errors.name?.message}</Error> </div>) : ""}
                            </Form.Group> 

							<Controller
								name="phone"
								control={control}
								render={({ field }) => (
									<ReactInputMask
										mask="(99) 99999-9999"
										value={field.value}
										onChange={field.onChange}
									>
										{(inputProps: any) => (
											<Form.Group className="mb-3">
												<Form.Label className="text-darker-grey">
													{translation("lead.phone")}:
												</Form.Label>
												<br />
												<Form.Control
													type="text"
													placeholder={translation(
														"lead.phone"
													)}
													{...inputProps}
												/>
											</Form.Group>
										)}
									</ReactInputMask>
								)}
							/>

							<p className="font-12 mb-4 font-light">
								Ao continuar você concorda com as{" "}
								<b>políticas de privacidade</b> e{" "}
								<b>termos de uso</b> da DStore.
							</p>

							{loadingSubmitLead ? (
								<div className="mb-4 text-center">
									<Spinner
										animation="border"
										variant="primary"
										style={{
											width: "2rem",
											height: "2rem",
										}}
									/>
								</div>
							) : (
								<Button
									variant="primary"
									className="w-100 mb-4"
									type="submit"
								>
									{translation("lead.continue")}
								</Button>
							)}

                            {
                                loadingSubmitLead ? (
                                    <div className="mb-4 text-center">
                                        <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem' }} />
                                    </div>
                                ) : (
                                    <Button id="leadSave" name="leadSave" variant="primary" className="w-100 mb-4" type="submit">
                                        {translation('lead.continue')}
                                    </Button>
                                )
                            }
                            
                            
                        </Form> */}

						<div className="text-center mb-0 px-4">
							<Link
								to={"/login"}
								className="w-100 mb-4 d-flex align-items-center justify-content-center gap-2 p-1 login-button"
								style={{
									color: colors.mainColors.minsk,
									border: `1px solid ${colors.mainColors.minsk}`,
									borderRadius: 4,
								}}
							>
								<em
									className="material-icons-outlined"
									style={{ fontSize: 18 }}
								>
									login
								</em>
								<span>{translation("lead.login")}</span>
							</Link>
						</div>

					</Col>
				</Row>
			</Modal>
		</Container>
	);
};
